import { useState, useEffect } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { ApiLink } from "../APILink/ApiLink";
import authHeader from "../Auth/authHeader";
import axios from "axios";
import { useAccountsByLedger } from "../UseDataReader/useAccountsByLedger";

export default function AccountsAutocompleteEdit({
  ledgerID,
  reloadKey,
  accountID,
  onSelect,
  onClear,
  label = "",
  labelId,
  textFieldWidth,
}) {
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const headers = authHeader();

  const { listAccounts, loadingInitial, loadingMore, setPage, hasMore } =
    useAccountsByLedger({ ledgerID, searchTerm });

  // =========================
  // PRELOAD ARTIKULLI (EDIT)
  // =========================
  useEffect(() => {
    if (!accountID) {
      setValue(null);
      setInputValue("");
      return;
    }

    let active = true;

    const loadById = async () => {
      try {
        const res = await axios.get(
          `${ApiLink.API_URL}Accounts/pick/${accountID}`,
          { headers },
        );

        if (!active) return;

        const accounts = res.data;
        setValue(accounts);
        setInputValue(
          `${accounts.IdentificationNumber} - ${accounts.AccountName}`,
        );
      } catch (err) {
        console.error("Failed to load account by id", err);
      }
    };

    loadById();

    return () => {
      active = false;
    };
  }, [accountID]);

  // =========================
  // SEARCH (debounce)
  // =========================
  useEffect(() => {
    const delay = setTimeout(() => {
      setSearchTerm(inputValue);
      setPage(1);
    }, 300);

    return () => clearTimeout(delay);
  }, [inputValue, setPage]);

  // =========================
  // Infinite scroll
  // =========================
  const handleScroll = (event) => {
    const listbox = event.currentTarget;
    if (
      listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 5 &&
      hasMore &&
      !loadingMore
    ) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    setSearchTerm("");
    setPage(1);
  }, [reloadKey]);

  return (
    <Autocomplete
      fullWidth
      options={listAccounts}
      value={value}
      inputValue={inputValue}
      id={labelId}
      onChange={(_, option) => {
        if (!option) {
          setValue(null);
          setInputValue("");
          onClear?.();
          return;
        }
        setValue(option);
        setInputValue(`${option.IdentificationNumber} - ${option.AccountName}`);
        onSelect?.(option);
      }}
      onInputChange={(e, v, reason) => {
        if (reason === "input") {
          setInputValue(v);
        }
      }}
      onOpen={() => {
        // Kur hapet dropdown, reset searchTerm vetëm nëse input nuk po shkruhet
        setSearchTerm("");
      }}
      isOptionEqualToValue={(o, v) => o.AccountID === v?.AccountID}
      getOptionLabel={(o) =>
        o ? `${o.IdentificationNumber} - ${o.AccountName}` : ""
      }
      ListboxProps={{
        style: { maxHeight: 200, overflow: "auto" },
        onScroll: handleScroll,
      }}
      loading={loadingInitial}
      filterOptions={(x) => x}
      renderOption={(props, option, { index }) => (
        <li
          {...props}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {/* <div>
            <div>{option.IdentificationNumber}</div>
            <div style={{ fontSize: 15 }}>{option.AccountName}</div>
          </div> */}

          <div>
            <div>{option.IdentificationNumber}</div>
            <div style={{ fontSize: 15, fontWeight: "bold" }}>
              {option.AccountName}
            </div>
          </div>
          {/* <div>
            <strong>{(option.SalesPrice ?? 0).toFixed(2)}€</strong>
            {loadingMore && index === listArticles.length - 1 && (
              <CircularProgress size={14} />
            )}
          </div> */}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          style={{ width: textFieldWidth || "95%" }}
        />
      )}
    />
  );
}
